<template>
  <form @submit.prevent="save">
    <div class="row">
      <div class="form-group col-xs-12 col-md-6">
        <w-input :model="$schema.name" :title="$t($schema.name.$schema.title)" />
      </div>

      <div class="form-group col-xs-12 col-md-6">
        <w-input :model="$schema.www" :title="$t($schema.www.$schema.title)" />
      </div>

      <div class="form-group col-xs-12 col-md-6">
        <w-input :model="$schema.phoneNumber" :title="$t($schema.phoneNumber.$schema.title)" />
      </div>

      <div class="form-group col-xs-12 col-md-6">
        <w-input :model="$schema.email" :title="$t($schema.email.$schema.title)" />
      </div>

      <div class="form-group col-xs-12 col-md-6">
        <w-input :model="$schema.postalCode" :title="$t($schema.postalCode.$schema.title)" />
      </div>

      <div class="form-group col-xs-12 col-md-6">
        <w-input :model="$schema.city" :title="$t($schema.city.$schema.title)" />
      </div>

      <div class="form-group col-xs-12 col-md-6">
        <w-input :model="$schema.street" :title="$t($schema.street.$schema.title)" />
      </div>

      <div class="form-group col-xs-12 col-md-3">
        <w-input :model="$schema.homeNumber" :title="$t($schema.homeNumber.$schema.title)" />
      </div>

      <div class="form-group col-xs-12 col-md-3">
        <w-input :model="$schema.localNumber" :title="$t($schema.localNumber.$schema.title)" />
      </div>

      <div class="form-group col-xs-12 col-md-12">
        <w-textarea :model="$schema.description" :title="$t($schema.description.$schema.title)" />
      </div>

      <div class="col-12 text-right">
        <button type="submit" class="btn btn-smart btn-lg rounded-pill">{{ $t('buttons.save') }}</button>
      </div>
    </div>
  </form>
</template>

<script>
import { formViewMixin } from '@/mixins/formView';
import schema from '@/schemas/club.schema';

const emptyData = () => ({
  name: '',
  phoneNumber: '',
  email: '',
  www: '',
  description: '',
  city: '',
  street: '',
  localNumber: '',
  homeNumber: '',
  postalCode: '',
  terc: '',
  woj: '',
  pow: '',
  gmi: ''
});

const messages = {
  added: 'messages.club.added',
  addError: 'messages.club.addError',
  formError: 'messages.club.formError',
  updated: 'messages.club.updated',
  updateError: 'messages.club.updateError'
};

// @vuese
// Formularz klubu
// @group Club
export default {
  schema,
  mixins: [formViewMixin('club', messages, emptyData)]
};
</script>
